import { Action } from 'redux'

export interface TransfersState {
  loadingTransfers: boolean
  savingTransfer: boolean
  removingTransfer: boolean
  transfers: any[]
  selectedIndex: number | null
  isEditing: boolean
  filters: {
    dateFrom: string
    dateTo: string
  }
}

export enum TransfersActionTypes {
  EDITING_START = '@@transfers/EDITING_START',
  EDITING_CANCEL = '@@transfers/EDITING_CANCEL',

  GET_TRANSFERS_START = '@@transfers/GET_TRANSFERS_START',
  GET_TRANSFERS_SUCCESS = '@@transfers/GET_TRANSFERS_SUCCESS',
  GET_TRANSFERS_ERROR = '@@transfers/GET_TRANSFERS_ERROR',

  SAVE_TRANSFER_START = '@@transfers/SAVE_TRANSFER_START',
  SAVE_TRANSFER_SUCCESS = '@@transfers/SAVE_TRANSFER_SUCCESS',
  SAVE_TRANSFER_ERROR = '@@transfers/SAVE_TRANSFER_ERROR',

  REMOVE_TRANSFER_START = '@@transfers/REMOVE_TRANSFER_START',
  REMOVE_TRANSFER_SUCCESS = '@@transfers/REMOVE_TRANSFER_SUCCESS',
  REMOVE_TRANSFER_ERROR = '@@transfers/REMOVE_TRANSFER_ERROR',

  SET_FILTERS = '@@transfers/SET_FILTERS',

  CLEAR = '@@transfers/CLEAR',
}

export interface TransfersAction extends Action<TransfersActionTypes> {
  index?: number
  transfers?: TransfersState['transfers']
  filters?: TransfersState['filters']
}
